// extracted by mini-css-extract-plugin
export default {"wrapper":"Y1-z","play":"Z1-z"};